
/* VENDOR */

import "nvd3/build/nv.d3.css";

import "dragula/dist/dragula.css";

import "./theme-base.sass";
import "./theme-typography.sass";
import "./theme-containers.sass";
import "./theme-forms.sass";

import "./theme-ng-date-picker-overrides.sass";
import "./theme-browser-overrides.sass";
import "./theme-smart-table.sass";
import "./theme-utils.sass";

import "./bFloatingHeader/bFloatingHeader.sass";
import "./bHeader/bHeader.sass";
import "./bSubHeader/bSubHeader.sass";
import "./bCalendarWidget/bCalendarWidget.sass";
import "./bMonthPicker/bMonthPicker.sass";
import "./bCurrencyChange/bCurrencyChange.sass";
import "./bLoading/bLoading.sass";
import "./bModalDialog/bModalDialog.sass";
import "./bModalVideo/bModalVideo.sass";
import "./bModalTermsOfUse/bModalTermsOfUse.sass";
import "./bSearchAndSelect/bSearchAndSelect.sass";
import "./bSpinner/bSpinner.sass";
import "./bToggleInput/bToggleInput.sass";
import "./bInputCheckbox/bInputCheckbox.sass";
import "./bIndeterminateCheckbox/bIndeterminateCheckbox.sass";
import "./vendor/ngDatepicker.sass";
import "./bProgressBar/bProgressBar.sass";

import "./pStyleguide/pStyleguide.sass";

import "./bAsyncSearch/bAsyncSearch.sass";


import { bFloatingHeaderDirective } from './bFloatingHeader/bFloatingHeader.directive';

import { bHeaderDirective } from './bHeader/bHeader.directive';
import { bSubHeaderDirective } from './bSubHeader/bSubHeader.directive';

import { bCalendarWidgetDirective } from './bCalendarWidget/bCalendarWidget.directive';
import { bMonthPickerDirective } from './bMonthPicker/bMonthPicker.directive';
import { bCurrencyChangeDirective } from './bCurrencyChange/bCurrencyChange.directive';

import { bFileReaderDirective } from './bFileReader/bFileReader.directive';
import { bFileDropzoneDirective } from './bFileDropzone/bFileDropzone.directive';

import { bModalDialogDirective } from './bModalDialog/bModalDialog.directive';
import { bModalVideoDirective } from './bModalVideo/bModalVideo.directive';
import { bModalTermsOfUseDirective } from './bModalTermsOfUse/bModalTermsOfUse.directive';

import { bProgressBarDirective }    from './bProgressBar/bProgressBar.directive';

import { bSearchAndSelectDirective } from './bSearchAndSelect/bSearchAndSelect.directive';
import { bSearchDirective } from './bSearchAndSelect/bSearch.directive';

import { bSpinnerDirective } from './bSpinner/bSpinner.directive';

import { bToggleInputDirective } from './bToggleInput/bToggleInput.directive';
import { bInputCheckboxDirective } from './bInputCheckbox/bInputCheckbox.directive';
import { bIndeterminateCheckboxDirective } from './bIndeterminateCheckbox/bIndeterminateCheckbox.directive';

import { pStyleguideDirective } from './pStyleguide/pStyleguide.directive';

import { momentFilter } from './utils/moment.filter';
import { monthFilter } from './utils/month.filter';
import { zerosPaddingFilter } from './utils/zerosPadding.filter';
import { hhmmssFilter } from './utils/hhmmss.filter';
import { truncateTextFilter } from './utils/truncateText.filter';
import { hmsFilter } from './utils/hms.filter';
import { hmFilter } from './utils/hm.filter';
import { hmsaFilter } from './utils/hmsa.filter';

import { LanguageService } from './utils/Language.service';
import {BundleService} from "theme/utils/Bundle.service";

import { DownloadFileService } from './utils/DownloadFile.service';
import { SortService } from './utils/Sort.service';

import { TitlesService } from './utils/Titles.service';
import { bModalService } from './bModalDialog/bModal.service';
import { IncomesAvailableService } from './utils/IncomesAvailable.service';

import { bAsyncSearchDirective } from './bAsyncSearch/bAsyncSearch.directive';

export default angular.module('frontend.theme', ["angular-inview"])
  .directive('bModalDialog', bModalDialogDirective)
  .directive('bModalVideo', bModalVideoDirective)
  .directive('bModalTermsOfUse', bModalTermsOfUseDirective)
  .directive('bProgressBar', bProgressBarDirective)
  .directive('bSearchAndSelect', bSearchAndSelectDirective)
  .directive('bSearch', bSearchDirective)
  .directive('bFloatingHeader', bFloatingHeaderDirective)
  .directive('bHeader', bHeaderDirective)
  .directive('bSubHeader', bSubHeaderDirective)
  .directive('bCalendarWidget', bCalendarWidgetDirective)
  .directive('bMonthPicker', bMonthPickerDirective)
  .directive('bCurrencyChange', bCurrencyChangeDirective)
  .directive('bFileReader', bFileReaderDirective)
  .directive('bFileDropzone', bFileDropzoneDirective)
  .directive('bSpinner', bSpinnerDirective)
  .directive('bInputCheckbox', bInputCheckboxDirective)
  .directive('bIndeterminateCheckbox', bIndeterminateCheckboxDirective)
  .directive('bToggleInput', bToggleInputDirective)
  .directive('pStyleguide', pStyleguideDirective)
  .directive('bAsyncSearch', bAsyncSearchDirective)
  .service('bModal', bModalService)
  .service('Language', LanguageService)
  .service('Bundle', BundleService)
  .service('DownloadFile', DownloadFileService)
  .service('Sort',SortService)
  .service('Titles', TitlesService)
  .service('IncomesAvailable', IncomesAvailableService)
  .filter('zpad', zerosPaddingFilter)
  .filter('moment', momentFilter)
  .filter('month', monthFilter)
  .filter('hhmmss', hhmmssFilter)
  .filter('hms', hmsFilter)
  .filter('hmsa', hmsaFilter)
  .filter('hm', hmFilter)
  .filter('truncTxt', truncateTextFilter);
